import { Container } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import type { ContainerProps } from '@mui/material';

const useStyles = makeStyles({ name: 'SiteContainer' })((theme) => ({
  root: {
    height: '100%',
    paddingBottom: theme.spacing(6),
    flex: 1,

    [theme.breakpoints.up('md')]: {
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: theme.spacing(8),
    },
  },
  displayFlex: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
}));

interface SiteContainerProps extends ContainerProps {
  readonly display?: 'block' | 'flex';
}

export const SiteContainer: React.FC<SiteContainerProps> = ({ children, display = 'block', ...restProps }) => {
  const { classes, cx } = useStyles();

  return (
    <Container
      className={cx(classes.root, display === 'flex' && classes.displayFlex)}
      maxWidth="md"
      {...restProps}
    >
      {children}
    </Container>
  );
};
